<script setup lang="ts">
  import PhysicalLocationsList from './PhysicalLocationsList.vue';
</script>

<template>
  <PhysicalLocationsList />
</template>
